import { render, staticRenderFns } from "./Colorimetros.vue?vue&type=template&id=446635f7&scoped=true"
import script from "./Colorimetros.vue?vue&type=script&lang=js"
export * from "./Colorimetros.vue?vue&type=script&lang=js"
import style0 from "./Colorimetros.vue?vue&type=style&index=0&id=446635f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446635f7",
  null
  
)

export default component.exports